import { curry } from 'ramda';

import { compact } from '../../../../helpers/compact';
import { FILTER } from '../../../../types/filters';
import { HubSlice, HubSliceType } from '../../../../types/hub';

const FILTER_MAPPING: Record<string, string> = {
  filter_thematic: FILTER.THEMATIC,
  filter_format: FILTER.CATEGORY,
  filter_localisation: FILTER.REGION,
  filter_dateRange: FILTER.DATE_RANGE,
};

const processFilters = (data: Record<string, any>) =>
  Object.entries(data).reduce(
    (acc, [k, v]) =>
      FILTER_MAPPING[k]
        ? {
            ...acc,
            [FILTER_MAPPING[k]]: v === 'oui' ? true : false,
          }
        : acc,
    {}
  );

const hubSlice = (parentType: string, data: Record<string, any>): HubSlice =>
  compact({
    type: HubSliceType.HUB,
    filters: processFilters(data?.primary),
    parentType,
    className: `${parentType}__${HubSliceType.HUB}`,
  });

export default curry(hubSlice);
